import {
	ERROR_SECTION_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/ErrorSectioni18nConstants';

export const ERROR_SECTION_I18N_EN = {
	[ERROR_SECTION_I18N_KEYS.error_title]:            "Errors",
	[ERROR_SECTION_I18N_KEYS.error_remarks]:          "Error analysis will not be conducted on the source_link column as it is an optional column.",
	[ERROR_SECTION_I18N_KEYS.total_rows_with_errors]: "Total rows with errors:",
	[ERROR_SECTION_I18N_KEYS.location_of_errors]:     "Location of Errors:",
	[ERROR_SECTION_I18N_KEYS.row_header]:             "Row",
	[ERROR_SECTION_I18N_KEYS.error_header]: 		  "Error",
	[ERROR_SECTION_I18N_KEYS.no_rows_with_relevant_data]:	   "No rows with relevant data",
	[ERROR_SECTION_I18N_KEYS.all_rows_have_no_content_column]: "All rows have no content column"
};



// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/error_section_i18n.en.js